import React, { useEffect, useState } from 'react';
import classes from "./SearchComponent.module.css"
import Input from '../../../Components/Inputs/Input/Input';
import { faSearchengin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchBook } from '../../../Store/actions/BestSellerBookAction';
import { removeUnpairedQuotes } from '../../../Util';
import { getSuggestionsForBestSellerBooks } from '../../../Store/actions/BookAction';
import SearchWithDropdown from '../../../Components/SearchWithDropdown/SearchWithDropdown';
const SearchIcon = "/Assets/Icons/icon-search.svg"

const SearchComponent = ({query, onChange,setQuery,minYear,maxYear,selectedGenres,allowedMinPublishingYear,allowedMaxPublishingYear, onSearch,searchCriteria,setSearchCriteria}) => {

  const handleSearchOnKeyPress = (e) => {
    if(e.key === "Enter"){
      onSearch();
    } else {
      const disallowedCharacters = ["(", "{", "[","]","}",")"];
      if (disallowedCharacters.includes(e.key)) {
        e.preventDefault();
      }
    }
  }

  const handleInputPaste = (e) => {
    e.preventDefault();
  
    const pastedText = e.clipboardData.getData("text").replace(/[\(\)\{\}\[\]]/g, ""); // Remove disallowed characters
    const input = e.target;
    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;
  
    const updatedQuery =
      query.substring(0, selectionStart) + pastedText + query.substring(selectionEnd);
  
    onChange({ target: { value: updatedQuery } });
  };

  const [allRecommendations,setAllRecommendations] = useState([]);

  const [searchRecommendations,setSearchRecommedations] = useState([]);
  const [recommendationClicked,setRecommendationClicked] = useState(false);
  const [focus,setFocus] = useState(false);
  const [blurTimeout, setBlurTimeout] = useState(null);

  const handleRecommendationClick = (recommendation) => {

    const sanitizedText = recommendation?.replace(/[\(\)\{\}\[\]]/g, ""); // Remove disallowed characters
    setQuery(sanitizedText);
    setSearchRecommedations([]);
    setRecommendationClicked(true);
  };
 
  const getFilter = () => {
    let filter = {
      limit: 10,
      offset:0,
      where: {
        $and: [],
      },
    };

    if (query) {
       let updatedQuery = removeUnpairedQuotes(query);
       updatedQuery = `"${updatedQuery}"`
        filter.where.$and.push({
          $or: [
            { author: `*${updatedQuery}*` },
            { title: `*${updatedQuery}*` },
            { language: `*${updatedQuery}*` },
            { sku: `*${updatedQuery}*` },
            { isbnNo: `*${updatedQuery}*` },
          ],
        });
      }

    if (
      (minYear || maxYear) &&
      !(
        minYear === allowedMinPublishingYear &&
        maxYear === allowedMaxPublishingYear
      )
    ) {
      const publishingYearCondition = {
        publishingYear: `[${
          minYear === allowedMinPublishingYear
            ? "*"
            : minYear || "*"
        } TO ${
          maxYear === allowedMaxPublishingYear
            ? "*"
            : maxYear || "*"
        }]`,
      };
      filter.where.$and.push(publishingYearCondition);
    }

    if (selectedGenres?.length > 0) {
      filter.where.$and.push({ genres: selectedGenres.join(",") });
    }
    return filter;
  };

  function getSet(obj) {
    return Array.from(
      Object.keys(obj).reduce((prev, curr) => {
        obj[curr].forEach(e => {
          prev.add(e.value);
        });
        return prev;
      }, new Set())
    );
  }

  
  useEffect(() => {
    if(recommendationClicked) {
      onSearch();
      setRecommendationClicked(false);
    }
  },[recommendationClicked])
  
  useEffect(() => {
    if (query) {
      const timeout = setTimeout(() => {
        fetchPageData();
      },500);
    
       return () => clearTimeout(timeout);
    }
  }, [query]);
  
  useEffect(() => {
    if (query) {
      const words = query.trim().split(/\s+/);
      setSearchRecommedations(
        allRecommendations
      );
    } else {
      setSearchRecommedations([]);
    }
  }, [query, allRecommendations]);

  const handleFocus = () => {
    if (blurTimeout) {
      clearTimeout(blurTimeout); 
    }
    setFocus(true);
  };

  const handleBlur = () => {
    const timeout = setTimeout(() => setFocus(false), 1000);
    setBlurTimeout(timeout);
  };

  const fetchPageData = async () => {
    if (query !== "") {
        const data = await getSuggestionsForBestSellerBooks(
          query,
          searchCriteria,
          15
        );

        const uniqueRecommendations = [];
        const seenValues = new Set(); // This will store lowercase versions for comparison
    
        const queryLower = query.toLowerCase();
    
        data?.forEach((book) => {
          // Check title matches
          if (book?.title) {
            const titleLower = book.title.toLowerCase();
            if (titleLower.includes(queryLower) || 
                queryLower.split(" ").some(word => titleLower.includes(word))) {
              // Check if we've already seen this title (case-insensitive)
              if (!seenValues.has(titleLower)) {
                uniqueRecommendations.push(book.title); // Keep original capitalization for display
                seenValues.add(titleLower); // Add lowercase version for comparison
              }
            }
          }
          
          // Check author matches
          if (book?.author) {
            const authorLower = book.author.toLowerCase();
            if (authorLower.includes(queryLower) || 
                queryLower.split(" ").some(word => authorLower.includes(word))) {
              // Check if we've already seen this author (case-insensitive)
              if (!seenValues.has(authorLower)) {
                uniqueRecommendations.push(book.author); // Keep original capitalization for display
                seenValues.add(authorLower); // Add lowercase version for comparison
              }
            }
          }
        });
        
        setAllRecommendations(uniqueRecommendations);
      }
    };
  
  return (
    <SearchWithDropdown 
    query={query}
     setQuery={setQuery}
      searchRecommendations={searchRecommendations} 
      handleRecommendationClick={handleRecommendationClick} 
      handleSearch={onSearch} 
      searchCriteria={searchCriteria}
      setSearchCriteria={setSearchCriteria}
    />
  );
};

export default SearchComponent;
